import React, { useContext } from "react"
import Step1 from "./Step1"
import Step2 from "./Step2"
import Step3 from "./Step3"
import { Link } from "gatsby"
import * as s from "./index.module.less"
import { SpaceProfileContext } from "../context"
import ProgressDots from "../../ProgressDots"
import ContactForm from "./ContactForm"
import isOnDemand from "../../../utils/isOnDemand"
import OnDemand from "./OnDemand"

const InlineBookTour = ({ space, isCms = false, locationsUuid, apiData }) => {
  const {
    commonData: {
      contextMinDate,
      bookTourStep,
      contextDate,
      calendarLoaded,
      calendar,
    },
  } = useContext(SpaceProfileContext)

  if (isOnDemand()) {
    return (
      <div className={s.outer_wrapper}>
        <div
          className={`${s.wrapper} ${s.no_min_height} d-flex align-items-center`}
        >
          <OnDemand />
        </div>
        <CovidMessage />
      </div>
    )
  }

  if (!calendarLoaded) {
    return (
      <div className={`${s.wrapper} d-flex align-items-center`}>
        <ProgressDots active />
      </div>
    )
  }
  if (!calendar.calendar_id) {
    return (
      <div className={s.outer_wrapper}>
        <div className={`${s.wrapper}`}>
          <ContactForm space={space} isCms={isCms} />
        </div>
        <CovidMessage />
      </div>
    )
  }
  return (
    <div className={s.outer_wrapper}>
      <div className={s.wrapper}>
        {bookTourStep === 1 && <Step1 space={space} apiData={apiData} />}
        {bookTourStep === 2 && <Step2 />}
        {bookTourStep === 3 && (
          <Step3
            space={space}
            locationsUuid={locationsUuid}
            apiData={apiData}
          />
        )}
      </div>
      <CovidMessage />
    </div>
  )
}

export default InlineBookTour

export const CovidMessage = ({ center = false }) => {
  return null
  return (
    <div className={s.covid_message}>
      <p className={center ? "text-center" : "text-start"}>
        💡Please note that as of October 22, 2021, we require proof of full
        vaccination for COVID-19 to enter our workspaces. Learn more about our{" "}
        <Link to={"/safety-policies"}>COVID-19 safety policies.</Link>
      </p>
    </div>
  )
}
